module.exports = __webpack_public_path__ + "img/ui_add.8f0756e.png";